import { Completion } from '@codemirror/autocomplete';

const escapeRegexSource = (source: string): string => {
  return source.replace(/[-[\]{}()*+?.,\\^$|]/g, '\\$&');
};

const regexSourceFromSet = (s: Set<string>): string => {
  return `[${escapeRegexSource(Array.from(s.keys()).join(''))}]`;
};

export const regexFromSuggestions = (suggestions: Completion[]): RegExp => {
  const first = new Set<string>();
  const rest = new Set<string>();
  for (const s of suggestions) {
    if (s.label.length > 0) {
      first.add(s.label[0]);
      for (const char of s.label) {
        rest.add(char);
      }
    }
  }
  const source = `${regexSourceFromSet(first)}${regexSourceFromSet(rest)}*$`;

  return new RegExp(source, 'i');
};

export const regexFromPrefixAndSuggestions = (
  prefixRegexSource: RegExp,
  suggestionRegexSource: RegExp,
): RegExp =>
  new RegExp(
    `${prefixRegexSource.source}(${suggestionRegexSource.source})?$`,
    prefixRegexSource.flags + 'i',
  );
